<template>
  <div class="page agent-app-push-page">
    <bean-form
      :columns="columns"
      v-model="form"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class AgentAppPush extends Vue {
    form = {}

    get columns() {
      return [
        {
          prop: 'all_users',
          label: this.$t('sms.allAgents'),
          renderCell: {
            component: 'switch',
          }
        },
        !this.form.all_users && {
          prop: 'phones',
          label: this.$t('sms.phones'),
          renderCell: {
            component: 'select',
            required: true,
            props: {
              multiple: true,
              placeholder: this.$t('hint.searchByPhone'),
              xRemotePreload: async () => {
                const { data } = await this.$request.get('/agents', { params: { per_page: 50, locked_at_null: true } });
                return data.map(({ phone }) => ({ label: phone, value: phone }));
              },
              xRemoteSearch: async (keyword) => {
                const params = { miapay_wallet_holder_phone_cont: keyword, per_page: 50, locked_at_null: true };
                const { data } = await this.$request.get('/agents', params);
                return data.map(({ phone }) => ({ label: phone, value: phone }));
              }
            },
            domProps: {
              style: 'width: 100%',
            }
          }
        },
        {
          prop: 'messages.en',
          label: this.$t('sms.enMessage'),
          renderCell: {
            component: 'textarea',
            required: true,
            hint: this.$t('sms.messageHint', { variables: '{store_name}, {cashback}, {balance}' }),
            domProps: {
              style: 'width: 100%',
            },
          }
        },
        {
          prop: 'messages.fr',
          label: this.$t('sms.frMessage'),
          renderCell: {
            component: 'textarea',
            required: true,
            hint: this.$t('sms.messageHint', { variables: '{store_name}, {cashback}, {balance}' }),
            domProps: {
              style: 'width: 100%',
            },
          }
        }
      ];
    }

    async handleSubmit(data) {
      const response = await this.$autoLoading(this.$request.post('/notifications/agent_app_push', data));
      this.$message.success(this.$t('operateSuccess'));
      this.$router.push({ name: 'push_notification_histories.show', params: { id: response.id } });
    }
  }

  export const route = [
    {
      path: '/agent_app_push',
      name: 'agent_app_push.index',
      component: AgentAppPush,
      props: {
        type: 'index',
      }
    }
  ]
</script>

<style lang="scss" scoped>
  .agent-app-push-page {
    max-width: 1000px;
    padding: 20px 30px;
  }
</style>
